import axiosService from '@/services/axios/axios.service';

const getFolders = async (payload: {
    prefix: string;
}): Promise<NonNullable<string[]>> => {
    const response = await axiosService.get('/aws-s3/folders', {
        params: payload,
    });
    return response.data.folders;
};

const getFiles = async (payload: {
    prefix: string;
}): Promise<
    NonNullable<
        {
            key: string;
            url: string;
            lastModified: string;
            eTag?: string;
        }[]
    >
> => {
    const response = await axiosService.get('/aws-s3/images', {
        params: payload,
    });
    return response.data.images;
};

/**
 * 
 * @param payload 
 * @UseGuards(JwtGuard)
  @UseGuards(RoleGuard)
  @Roles(UserRole.ADMIN)
  async deleteImage(@Query('key') key: string) {
    return this.awsS3.deleteFile(key);
  }
 * @returns 
 */

const deleteFile = async (payload: { key: string }): Promise<void> => {
    const response = await axiosService.delete('/aws-s3/delete', {
        params: payload,
    });
    return response.data;
};

const deleteFolder = async (payload: { key: string }): Promise<void> => {
    const response = await axiosService.delete('/aws-s3/delete-folder', {
        params: payload,
    });
    return response.data;
};

const detectIdenticalScreenshots = async (payload: {
    prefix: string;
}): Promise<{
    groups: Array<{
        hash: string;
        files: Array<{
            key: string;
            url: string;
            lastModified: string;
        }>;
    }>;
    totalIdenticalGroups: number;
    totalDuplicateFiles: number;
}> => {
    const response = await axiosService.get('/aws-s3/detect-identical-screenshots', {
        params: payload,
    });
    return response.data;
};

export { getFolders, getFiles, deleteFile, deleteFolder, detectIdenticalScreenshots };
